import { ReactNode } from 'react';

export const AnimatedContent = ({ children, ...props }: { children: ReactNode }) => {
  return (
    <div {...props}>
      {children}
    </div>
  );
}
